import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=0388dc14&scoped=true"
import script from "./landingpage.vue?vue&type=script&setup=true&lang=js"
export * from "./landingpage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./landingpage.vue?vue&type=style&index=0&id=0388dc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388dc14",
  null
  
)

export default component.exports